import { Text } from "../services/db";

const getRelevantTexts = (storedTexts: Text[] | undefined, selectedTag: string | null) =>
	storedTexts && storedTexts.filter((storedText) => storedText.tag === selectedTag);

export default getRelevantTexts;
